// extracted by mini-css-extract-plugin
export default {"contents":"eH-z","sectionHeading":"fH-z"};